module.exports = "/img/14.680c52.webp";